import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import About from '../pages/About';
import Experience from '../pages/Experience';
import Contact from '../pages/Contact';
import Certifications from '../pages/Certifications';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/about' element={<About />} />
      <Route path='/experience' element={<Experience />} />
      <Route path='/contact' element={<Contact />} />
      <Route path='/certifications' element={<Certifications />} />
    </Routes>
  );
};

export default AppRoutes;